<div class="row no-gutters" [formGroup]="formGroup" *transloco="let t">
  <div class="form-group col-12">
    <app-date-input
      [childForm]="formGroup"
      formControlName="spzRecommendationIssued"
      [label]="t('child/spzRecommendationIssued')"
      [placeholder]="t('shared/selectDate')"
    >
    </app-date-input>
  </div>
  <div class="form-group col-12">
    <app-date-input
      [childForm]="formGroup"
      formControlName="spzRecommendationDue"
      [label]="t('child/spzRecommendationDue')"
      [placeholder]="t('shared/selectDate')"
    >
    </app-date-input>
  </div>
  <div class="form-group col-12">
    <app-text-input [childForm]="formGroup" formControlName="izoNumber" [label]="t('child/izoNumber')"></app-text-input>
  </div>
  <div class="form-group col-12">
    <div class="row no-gutters" *ngFor="let supportingMeasure of supportingMeasures.controls; let i = index">
      <div class="col-12 mb-2">
        <!-- Supporting Measure Card -->
        <div class="card border-light shadow-sm mb-3">
          <!-- Card Header -->
          <div class="card-header bg-light border-bottom-0 py-1">
            <div class="d-flex align-items-center justify-content-between w-100">
              <h6 class="mb-0">
                {{ t('child/supportingMeasureToggleTitle') }} {{ i + 1 }}
                <small
                  class="text-muted fw-normal ms-2"
                  *ngIf="supportedMeasureNameById(supportingMeasure.controls.supportingMeasure.value)"
                >
                  [{{ supportedMeasureNameById(supportingMeasure.controls.supportingMeasure.value) }}]
                </small>
              </h6>
              <div class="d-flex align-items-center gap-1">
                <button
                  type="button"
                  class="btn btn-sm btn-only-icon"
                  (click)="removeSupportingMeasure(i)"
                  [title]="t('child/removeSupportingMeasure')"
                >
                  <i class="material-symbols-rounded">delete</i>
                </button>
                <button type="button" class="btn btn-sm btn-only-icon" (click)="toggleCollapse(i)" [attr.aria-expanded]="!isCollapsed(i)">
                  <i class="material-symbols-rounded" [class.rotate-180]="!isCollapsed(i)"> expand_more </i>
                </button>
              </div>
            </div>
          </div>

          <!-- Card Body - Collapsible Content -->
          <div class="card-body" [ngClass]="{ 'd-none': isCollapsed(i) }">
            <app-child-supporting-measure-form
              [formGroup]="supportingMeasure"
              [allowRemove]="false"
              [supportingMeasureOptions]="supportingMeasureOptions"
              (remove)="removeSupportingMeasure(i)"
            ></app-child-supporting-measure-form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex align-items-center gap-2">
    <button *ngIf="allowRemove" type="button" class="btn btn-lg btn-icon btn-outline-primary me-4" (click)="removeRecommendation()">
      <i class="material-symbols-rounded">delete</i>
      {{ t('child/removeSpzRecommendation') }}
    </button>
    <button type="button" class="btn btn-lg btn-icon btn-outline-primary me-4" (click)="addSupportingMeasure()">
      <i class="material-symbols-rounded">add</i>
      {{ t('child/addSupportingMeasure') }}
    </button>
  </div>
</div>
